import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowFetchFailureAlert = ({
  handleRefetch
}) => /*#__PURE__*/_jsx(UIAlert, {
  use: "inline",
  type: "warning",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-management.WorkflowFetchFailureAlert.message"
  }),
  children: /*#__PURE__*/_jsx(UIButtonWrapper, {
    children: /*#__PURE__*/_jsx(UIButton, {
      onClick: handleRefetch,
      size: "extra-small",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowFetchFailureAlert.retry"
      })
    })
  })
});
export default WorkflowFetchFailureAlert;